/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountingContactDto } from './AccountingContactDto';
import type { ClientContactMappingDto } from './ClientContactMappingDto';
export type ClientWithMappingDto = {
    id: number;
    firstName: string;
    lastName: string;
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
        streetAndNumber: string;
        zip: string;
        city: string;
    };
    mapping?: ClientContactMappingDto | null;
    /**
     * Suggested contact match from the accounting provider
     */
    suggestedContact?: AccountingContactDto | null;
    /**
     * Confidence level of the suggested match
     */
    matchConfidence?: ClientWithMappingDto.matchConfidence;
};
export namespace ClientWithMappingDto {
    /**
     * Confidence level of the suggested match
     */
    export enum matchConfidence {
        EXACT = 'exact',
        NONE = 'none',
        LOW = 'low',
        MEDIUM = 'medium',
        HIGH = 'high',
    }
}

